import React from 'react';
// Components
import Sales from 'components/common/Sales';

const AthleteStoreSales: React.FC = () => {
  return <Sales />;
};

export default AthleteStoreSales;
